/* eslint-disable */
export default {
  activeCall: 'Aktiver Anruf',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
